module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3 col-sm-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-5"
  }, [_c('div', {
    staticClass: "icon-big text-center",
    class: ("icon-" + _vm.type)
  }, [_c('i', {
    class: _vm.icon
  })])]), _vm._v(" "), _c('div', {
    staticClass: "text-right col-xs-7 numbers"
  }, [_c('p', [_vm._v(_vm._s(_vm.title))]), _vm._v("\n                    " + _vm._s(_vm.formatValue ? _vm.numberFormatterThousand(_vm.value) : _vm.numberFormatter(_vm.value)) + "\n                ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b8a5b2ac!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/Cards/StatsCard.vue
// module id = 452
// module chunks = 1